import styled, { css, keyframes } from 'styled-components';
import { ANIMATION_CURVE, ANIMATION_DURATION } from '@optimus-web/common';
import { getLinearProgessToken } from './tokens';
import { LinearValueBarProps, ProgressMode } from './types';

const linearIndeterminateBar = keyframes`
    0% {
        transform: translate(-50%) scaleX(0);
    }

    50% {
        transform: translate(-0%) scaleX(0.3);
    }

    100% {
        transform: translate(50%) scaleX(0);
    }
`;

export const ProgressWrapper = styled.div`
    height: 4px;
    overflow: hidden;
    position: relative;
    width: 100%;
`;

export const LinearValueBar = styled.span<LinearValueBarProps>`
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: ${(props) => `scaleX(${props.scale})`};
    transform-origin: left center;
    transition-duration: ${ANIMATION_DURATION.default}ms;
    transition-timing-function: ${ANIMATION_CURVE.default};
    background-color: ${getLinearProgessToken('backgroundColor')};

    ${(props) =>
        props.mode === ProgressMode.Indeterminate &&
        css`
            animation: ${linearIndeterminateBar} 1s linear infinite;
            transform-origin: center center;
        `}
`;
